import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const MissionBlockRemoveModal = ({
  
  closeModal,
  action,
  attribute
}) => (<Modal
      closeModal={closeModal}
      size='sm'
      showCloseModal={false}
      className='pictograms-remove-modal'
    >

      <div className='pictogram-remove-modal-section'>

      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M36.881 5.2988H46.4932C49.5144 5.2988 51.9714 7.7272 51.9714 10.712V16.6192H47.4552V46.2644C47.4552 49.3714 44.993 52 42.0758 52H10.361C7.3034 52 4.5188 49.2648 4.5188 46.2644V16.6192H0V10.712C0 7.6778 2.3868 5.2988 5.4366 5.2988H15.3374C15.4882 2.353 17.8022 0 20.6492 0H31.2806C34.242 0 36.7354 2.4024 36.881 5.2988ZM20.6497 2.4752H31.2811C32.8671 2.4752 34.2243 3.7726 34.3777 5.2988H17.8417C17.9847 3.7232 19.1677 2.4752 20.6497 2.4752ZM2.478 14.144H49.4964V10.712C49.4964 9.0636 48.1756 7.774 46.4934 7.774H5.4368C3.778 7.774 2.478 9.0636 2.478 10.712V14.144ZM42.0765 49.5248C43.6235 49.5248 44.9807 48.0012 44.9807 46.2644V16.6192H6.99469V46.2644C6.99469 47.879 8.69509 49.5248 10.3617 49.5248H42.0765ZM22.425 22.4536H29.3618V41.0462C29.3618 42.64 28.5012 44.2546 26.8606 44.2546H25.5736C23.9278 44.2546 22.425 42.7258 22.425 41.0462V22.4536ZM26.8604 46.7324H25.5734C22.5782 46.7324 19.9496 44.0752 19.9496 41.0462V19.9784H31.8368V41.0462C31.8368 44.2884 29.697 46.7324 26.8604 46.7324ZM15.4653 41.0462V19.9784H8.9575V22.4536H12.9875V41.0462C12.9875 42.5906 11.9345 44.2546 10.2367 44.2546H8.9575V46.7324H10.2367C13.1201 46.7324 15.4653 44.1818 15.4653 41.0462ZM42.6435 46.7324H41.5489C38.6135 46.7324 36.1357 44.1272 36.1357 41.0462V19.9784H42.6435V22.4536H38.6109V41.0462C38.6109 42.7856 39.9577 44.2546 41.5489 44.2546H42.6435V46.7324Z" fill="#B42A27"/>
      </svg>

        <h3 style={{marginBottom: '16px'}}>Excluir</h3>
        {attribute && attribute.length > 1 ?
        <div className='pictogram-remove-multiples'>
          <span>Você selecionou {attribute.length} missões.</span>
          <span>Deseja excluí-los definitivamente do sistema?</span>
        </div>
        :
        <span style={{marginBottom: '16px'}}>Deseja excluir a permissão da missão?</span>}
        {attribute && attribute.length > 1 ? 
        
        <div className='pictogram-multiples-box' style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',  maxHeight: '350px', overflowY: 'auto'}}> 
          <span style={{color: '#3C3738', fontSize: 14, fontWeight: '600', textAlign: 'center', marginBottom: '8px'}}>Missões:</span>
          <div style={{display: 'flex', flexDirection: 'column', gap: '8px', width: '100%'}}> {attribute.map((m) => <span style={{textAlign: 'center'}} key={m.id}> {m.id} </span>)} </div>

        </div>  
        : 
        <span style={{fontWeight: '600', color:'#3C3738', fontSize: '14px', textAlign:"center"}}> {Array.isArray(attribute) ? attribute[0].id : attribute.id} </span>}


        <div className='pictogram-remove-modal-actions'>
          <button onClick={closeModal} id='pictogram-close'>Cancelar</button>
          <button onClick={action} id='pictogram-confirm-delete'>Sim, excluir</button>
        </div>
      </div>
      
    </Modal>
    )

MissionBlockRemoveModal.propTypes = {
 
  closeModal: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  attribute: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  multiples: PropTypes.array

}

export default Form({ fields: FIELDS })(MissionBlockRemoveModal)

export { MissionBlockRemoveModal }
